// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { Card } from '@kintent/glide';

export const Section = styled.section`
  width: 1200px;

  @media (min-width: 1920px) {
    width: 1400px;
  }

  margin-left: auto;
  margin-right: auto;

  display: flex;
  flex-direction: column;
  gap: 24px;

  & .documents-section-title,
  & .documents-section-featured-items-title {
    font-weight: 600;
  }

  & .documents-section-title {
    padding-top: 64px;
  }

  & .show-all-documents-cta {
    text-align: center;

    a {
      font-weight: 500;
    }
  }
`;

export const DocumentCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 36px;

  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 16px;
`;

export const DocumentCardGrid = styled('div', {
  shouldForwardProp(props) {
    return !['documentCardCount'].includes(props);
  },
})`
  display: grid;
  grid-template-columns: repeat(${({ documentCardCount }) => documentCardCount}, 1fr);
  column-gap: 20px;

  & .document-list-item {
    border-radius: 16px;
    cursor: pointer;
  }

  & .document-list-item-title {
    font-weight: 600;
  }

  & .document-list-item-description {
    display: -webkit-box;

    overflow: hidden;

    line-clamp: 2;
    -webkit-line-clamp: 2;

    -webkit-box-orient: vertical;

    font-weight: 500;
    font-family: Lato;
  }
`;
